import React from 'react'
import DateInputBase from './DateInputBase'
const DayInput = (props) => {
    const handleChange = (setInternalVal) => (e) => {
        const textVal = e.target.value
        let val

        if (textVal === '') {
            val = null
        } else {
            val = parseInt(e.target.value)

            if (!(val <= 31)) {
                return
            }
        }
        if (textVal.length === props.format.length) {
            props.focusNextInput()
        }

        setInternalVal(textVal)
    }

    return (
        <DateInputBase
            {...props}
            placeholder={'DD'}
            value={props.value || ''}
            handleInternalChange={handleChange}
            onChange={props.onChange}
            onBlur={(val, handleSetFinalValue, clearInput, zeroPadValue) => {
                handleSetFinalValue(val)
            }}
        />
    )
}

export default DayInput
